import React from "react";
import { List, Typography } from "antd";

const { Title, Text, Link } = Typography;

// Sample data for the publications
const publications = [
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_vlm3d.png",
        title:
            "Let Language Constrain Geometry: Vision-Language Models as Semantic and Spatial Critics for 3D Generation",
        authors: "Weimin Bai, Yubo Li, Weijian Luo, Zeqiang Lai, Yequan Wang, Wenzheng Chen, He Sun. ICML, 2026",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2511.14271",
        },
        {
            type: "Website",
            url: "https://ai4scientificimaging.org/VLM3D/",
        },{
            type: "Code",
            url: "https://github.com/AI4ImagingLab/VLM3D",
        }
        ],
        year: 2026,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_marval.png",
        title: "Masked Auto-Regressive Variational Acceleration:Fast Inference Makes Practical Reinforcement Learning",
        authors: "Yuxuan Gu, Weimin Bai, Yifei Wang, Weijian Luo, He Sun. CVPR, 2026",
        links: [
        {
            type: "Paper",
            url: "https://arxiv.org/abs/2511.15190",
        },
        {
            type: "Website",
            url: "https://ai4scientificimaging.org/MARVAL-RL/",
        },
        {
            type: "Code",
            url: "https://github.com/ai4imaging/MARVAL-RL-code",
        }
        ],
        year: 2026,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_instantvir.png",
        title: "InstantViR: Real-Time Video Inverse Problem Solver with Distilled Diffusion Prior",
        authors: "Weimin Bai, Suzhe Xu, Yiwei Ren, Jinhua Hao, Ming Sun, Wenzheng Chen, He Sun. CVPR, 2026",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2511.14208",
        },
        {
            type: "Website",
            url: "https://ai4scientificimaging.org/InstantViR/",
        }
        ],
        year: 2026,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_blind.png",
        title:
            "Blind Inversion using Latent Diffusion Priors",
        authors: "Weimin Bai, Siyi Chen, Wenzheng Chen, He Sun. TIP, 2026",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/pdf/2407.01027",
        }, {
            type: "Website",
            url: "https://ai4scientificimaging.org/LatentDEM/",
        },
        {
            type: "Code",
            url: "https://github.com/AI4ImagingLab/LatentDEM",
        }
        ],
        year: 2026,
    },

    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_dive3d.png",
        title:
            "Dive3D: Diverse Distillation-based Text-to-3D Generation via Score Implicit Matching",
        authors: "Weimin Bai, Yubo Li, Weijian Luo, Wenzheng Chen, He Sun. TMLR, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2506.13594",
        },
        {
            type: "Website",
            url: "https://ai4scientificimaging.org/Dive3D/",
        },{
            type: "Code",
            url: "https://github.com/AI4ImagingLab/Dive3D",
        }
        ],
        year: 2025,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_decoding.png",
        title: "Robust Single-shot Structured Light 3D Imaging via Neural Feature Decoding",
        authors: "Jiaheng Li, Qiyu Dai, Lihan Li, Praneeth Chakravarthula, He Sun, Baoquan Chen, Wenzheng Chen. Siggraph Asia, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2512.14028",
        }
        // {
        //     type: "Website",
        //     url: "https://ai4scientificimaging.org/instantvir",
        // }
        ],
        year: 2025,
    },
    
    
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_flowodt.png",
        title: "Pose-Free 3D Quantitative Phase Imaging of Flowing Cellular Populations",
        authors: "Enze Ye, Wei Lin, Shaochi Ren, Yakun Liu, Xiaoping Li, Hao Wang, He Sun, Feng Pan. arXiv, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2509.04848v1",
        },{
            type: "Code",
            url: "https://github.com/AI4ImagingLab/OmniFHT",
        }
        ],
        year: 2025,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_openwaves.png",
        title:
            "OpenBreastUS: Benchmarking Neural Operators for Wave Imaging Using Breast Ultrasound Computed Tomography",
        authors: "Zhijun Zeng, Youjia Zheng, Hao Hu, Zeyuan Dong, Yihang Zheng, Xinliang Liu, Jinzhuo Wang, Zuoqiang Shi, Linfeng Zhang, Yubing Li, He Sun. arXiv, 2025",
        year: 2025,
        links: [
            {
          type: "Paper",
          url: "https://arxiv.org/abs/2507.15035",
        },
        {
          type: "Website",
          url: "https://ai4scientificimaging.org/OpenWaves/",
        }
        ]
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_nwi.png",
        title:
            "Generative neural physics enables quantitative volumetric ultrasound of tissue mechanics",
        authors: "Zhijun Zeng, Youjia Zheng, Chang Su, Qianhang Wu, Hao Hu, Zeyuan Dong, Shan Gao, Yang Lv, Rui Tang, Ligang Cui, Zhiyong Hou, Weijun Lin, Zuoqiang Shi, Yubing Li, He Sun. arXiv, 2025",
        year: 2025,
        links: [
            {
          type: "Paper",
          url: "https://arxiv.org/abs/2508.12226",
        },
        ]
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_emgeneralist.png",
        title:
            "EM Generalist: A Physics-Driven Diffusion Foundation Model for Electron Microscopy",
        authors: "Enze Ye, Chixiang Lu, Zixuan Jiang, Weimin Bai, Shaochi Ren, Chenyu Wang, Jinyang Zhang, Ruohua Shi, Lei Ma, Kun Song, Xiaojuan Qi, Haibo Jiang, He Sun. Preprint, 2025",
        year: 2025,
        links: [{
            type: "Paper",
            url: "https://www.researchsquare.com/article/rs-6602548/v1",
        },
        {
            type: "Website",
            url: "http://generativemicroscope.com",
        },
        {
            type: "Code",
            url: "https://github.com/10cbvkw/EM_generalist",
        }
        ],
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_uniinstruct.png",
        title: "Uni-Instruct: One-step Diffusion Model through Unified Diffusion Divergence Instruction",
        authors: "Yifei Wang, Weimin Bai, Colin Zhang, Debing Zhang, Weijian Luo, He Sun. NeurIPS, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2505.20755",
        },
        {
            type: "Code",
            url: "https://github.com/a-little-hoof/Uni_Instruct",
        },
        ],
        year: 2025,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_FlowDAS.png",
        title:
            "FlowDAS: A Flow-Based Framework for Data Assimilation",
        authors: "Siyi Chen, Yixuan Jia, Qing Qu, He Sun, and Jeffrey A. Fessler. NeurIPS, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2501.16642",
        },
        {
            type: "Code",
            url: "https://github.com/AI4ImagingLab/FlowDAS",
        }],
        year: 2025,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_satellite.png",
        title:
            "Reconstructing Satellites in 3D from Amateur Telescope Images",
        authors: "Zhiming Chang, Boyang Liu, Yifei Xia, Youming Guo, Boxin Shi, He Sun. IEEE Transactions on Pattern Analysis and Machine Intelligence, 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/pdf/2404.18394",
        },{
            type: "Website",
            url: "https://ai4scientificimaging.org/ReconstructingSatellites",
        },{
            type: "Code",
            url: "https://github.com/AI4ImagingLab/3DSatellitesCode",
        }
        ],
        year: 2025,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_empmc.png",
        title:
            "Learning Diffusion Model from Noisy Measurement using Principled Expectation-Maximization Method",
        authors: "Weimin Bai, Weiheng Tang, Enze Ye, Siyi Chen, Wenzheng Chen, He Sun. ICASSP (Oral), 2025",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/pdf/2410.11241?",
        },
        {
            type: "Code",
            url: "https://github.com/weiminbai/EMDiffusion",
        }
        ],
        year: 2025,
    },

    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_emdiffusion.jpg",
        title:
            "An Expectation-Maximization Algorithm for Training Clean Diffusion Models from Corrupted Observations",
        authors: "Weimin Bai, Yifei Wang, Wenzheng Chen, He Sun. NeurIPS, 2024",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2407.01014",
        },
        {
            type: "Code",
            url: "https://github.com/weiminbai/EMDiffusion",
        }
        ],
        year: 2024,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_imaging.jpg",
        title:
            "Imaging biomacromolecules in action with liquid-phase electron microscopy",
        authors: "Jiaye Li, He Sun, Huan Wang. Trends in Chemistry, 2024",
        links: [{
            type: "Paper",
            url: "https://www.sciencedirect.com/science/article/abs/pii/S2589597424000674",
        }],
        year: 2024,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_m87.png",
        title: "The persistent shadow of the supermassive black hole of M 87",
        authors: "The Event Horizon Telescope Collaboration, Astronomy and Astrophysics 2024",
        links: [{
            type: "Paper",
            url: "https://www.aanda.org/articles/aa/full_html/2024/01/aa47932-23/aa47932-23.html",
        }],
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_discover.png",
        title:
            "Discovering Structure From Corruption for Unsupervised Image Reconstruction",
        authors: "Oscar Leong, Angela F.Gao, He Sun, Katherine L.Bouman. IEEE Transactions on Computational Imaging, 2023",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/pdf/2304.05589",
        },
        {
            type: "Website",
            url: "http://imaging.cms.caltech.edu/igm/",
        },
        {
            type: "Code",
            url: "https://github.com/angelafgao/IGM",
        }
        ],
        year: 2023,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication4.png",
        title: "Image Reconstruction without Explicit Priors",
        authors: "Oscar Leong, Angela F.Gao, He Sun, Katherine L.Bouman. ICASSP, 2023",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/pdf/2303.12217",
        },
        {
            type: "Website",
            url: "http://imaging.cms.caltech.edu/igm/",
        },
        ],
        year: 2023,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_filamentary.png",
        title: "Filamentary structures as the origin of blazar jet radio variability",
        authors: "The Event Horizon Telescope Collaboration. Nature Astronomy 2023",
        links: [{
            type: "Paper",
            url: "https://www.nature.com/articles/s41550-023-02105-7",
        }],
        year: 2023,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication6.jpg",
        title: "Recovering a Molecule's 3D Dynamics from Liquid-phase Electron Microscopy",
        authors: "Enze Ye, Yuhang Wang, Hong Zhang, Yiqin Gao, Huan Wang, He Sun. ICCV, 2023",
        links: [{
            type: "Paper",
            url: "https://arxiv.org/abs/2308.11927",
        },
        {
            type: "Website",
            url: "https://ai4scientificimaging.org/tempor",
        },
        {
            type: "Code",
            url: "https://github.com/AI4ImagingLab/tempor_code",
        }
        ],
        year: 2023,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication5.jpg",
        title: "Deep learning-assisted analysis of single molecule dynamics from liquid-phaseelectron microscopy",
        authors: "Bin Cheng, Enze Ye, He Sun, Huan Wang. Chemical Communications, 2023",
        links: [{
            type: "Paper",
            url: "https://pubs.rsc.org/en/content/articlelanding/2023/cc/d2cc05354c",
        },],
        year: 2023,
    },
    {
        image: process.env.PUBLIC_URL + "/rawdata/publication_dpi.png",
        title:
            "α-Deep Probabilistic Inference (α-DPI): efficient uncertainty quantification from exoplanet astrometry to black hole feature extraction",
        authors: "He Sun, Katherine L. Bouman, Paul Tiede, Jason J. Wang, Sarah Blunt, Dimitri Mawet. The Astrophysical Journal, 2022",
        links: [{
            type: "Paper",
            url: "https://iopscience.iop.org/article/10.3847/1538-4357/ac6be9/meta",
        },
        {
            type: "Website",
            url: "http://imaging.cms.caltech.edu/dpi/",
        },
        {
            type: "Code",
            url: "https://github.com/HeSunPU/DPI",
        }
        ],
        year: 2022,
    },

];

const sgra = {
    image: process.env.PUBLIC_URL + "/rawdata/publication_first.png",
    title: "First Sagittarius A* Event Horizon Telescope results. I-VI",
    authors: "The Event Horizon Telescope Collaboration. The Astrophysical Journal Letters, 2022",
    links: [{
        type: "Paper I",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6674",
    },
    {
        type: "Paper II",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6675",
    },
    {
        type: "Paper III",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6429",
    },
    {
        type: "Paper IV",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6736",
    },
    {
        type: "Paper V",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6672",
    },
    {
        type: "Paper VI",
        url: "https://iopscience.iop.org/article/10.3847/2041-8213/ac6756",
    },
    {
        type: "Website",
        url: "https://eventhorizontelescope.org/blog/astronomers-reveal-first-image-black-hole-heart-our-galaxy",
    }
    ],
    year: 2022,
}


const PublicationsList = () => {
    // Track the last year displayed
    let lastYear = null;

    return (
        <div className="w-4/5 sm:w-9/10 mx-auto pt-5 mb-0">
            <div className="flex flex-col items-center justify-center my-0">
                {/* 文字部分 */}
                <p className="text-lg text-gray-500 text-center mb-0">
                    <Title level={2}>Selected Publications</Title>
                    <p className="mt-2 mb-0">
                        please visit{" "}
                        <a
                            href="https://scholar.google.com/citations?user=c9V5HkYAAAAJ&hl=en&oi=ao"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 font-semibold hover:underline hover:text-blue-600"
                        >
                            Google Scholar
                        </a>{" "}
                        for the complete list of publications from our group
                    </p>
                </p>
            </div>
            <List
                itemLayout="vertical"
                dataSource={publications}
                renderItem={(item) => {
                    const showYear = item.year !== lastYear; // Check if the year has changed
                    lastYear = item.year; // Update the last year

                    return (
                        <>
                            {/* Display year if it changes */}
                            {showYear && (
                                <Title level={2} className="mt-8 mb-4 ml-2 text-gray-700">
                                    {item.year}
                                </Title>
                            )}
                            <List.Item>
                                {/* Flex Container */}
                                <div className="flex flex-col md:flex-row items-start md:space-x-4 space-y-4 md:space-y-0">
                                    {/* Image Section */}
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full md:w-72 object-cover rounded-md mr-5"
                                    />

                                    {/* Content Section */}
                                    <div className="w-full">
                                        <Title level={3} className="mb-5 mt-2">
                                            {item.title}
                                        </Title>
                                        <div className="block text-gray-600 mb-6 text-base">
                                            {item.authors}
                                        </div>

                                        {/* Link Section */}
                                        {item.links && item.links.length > 0 && (
                                            <div className="flex flex-wrap gap-4">
                                                {item.links.map((links, index) => (
                                                    <Link
                                                        key={index}
                                                        href={links.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 text-base underline"
                                                    >
                                                        {links.type}
                                                    </Link>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </List.Item>
                        </>
                    );
                }}
            />



            <div className="custom-divider"></div>
            <div className="flex flex-col md:flex-row items-start md:space-x-4 space-y-4 md:space-y-0 py-3">
                {/* Image Section */}
                <img
                    src={sgra.image}
                    alt={sgra.title}
                    className="w-full md:w-72 object-cover rounded-md mr-5"
                />

                {/* Content Section */}
                <div className="w-full">
                    <Title level={3} className="mb-5 mt-2">
                        {sgra.title}
                    </Title>
                    <Text className="block text-gray-600 mb-2 text-base">
                        {sgra.authors}
                    </Text>
                    <Text className="block text-gray-600 mb-6 text-base">
                        He Sun led the neural-network-based analysis of SgrA*'s variability and morphology in Paper IV,  featured in the
                        {" "}<a href="https://www.nobelprize.org/uploads/2024/09/advanced-physicsprize2024.pdf" style={{ whiteSpace: "nowrap", display: "inline-block" }}><i>Scientific Background

                            to the Nobel Prize in Physics 2024</i> </a>{" "} as a notable AI application in astronomy.
                    </Text>

                    {/* Link Section */}
                    {sgra.links && sgra.links.length > 0 && (
                        <div className="flex flex-wrap space-x-4">
                            {sgra.links.map((links, index) => (
                                <Link
                                    key={index}
                                    href={links.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 text-base underline"
                                >
                                    {links.type}
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>



        </div>
    );
};



export default PublicationsList;
